import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, FormGroup, InputGroup, H2, H4, H6, HTMLSelect, Icon } from '@blueprintjs/core';
import { TablePagination, Paper } from '@material-ui/core';
import Chart from 'react-apexcharts';
import MaterialTable from 'material-table';
import { estimatedClass } from '../common';
import { rounded, lemmaCat }  from '../../../utils.js';
import Cookies from 'js-cookie';
import { FRONT_USER_LANG_COOKIE_NAME } from '../../../auth/constants.js';


import './Chrono.css';

class ChronoCooc extends React.PureComponent {

  state = {
    displayType: 'freq', // freq|spec|timeSpec|size
    collocTypeChoice: 'collocType', // colloType|collocTTR
    nbCoocToDisplay: 5,
    currentColloc: this.props.data.sortedCollocs[0],
    filter: "",
    height:300,
  }

  initChart=()=> {
    this.setState({ height: 350 });
  }

  onTypeChange = (e) => {
    e.preventDefault();
    this.setState({ displayType: e.target.value });
  }
  onCollocTypeChoiceChange = (e) => {
    e.preventDefault();
    this.setState({ collocTypeChoice: e.target.value });
  }

  onFilterChange = (e) => {
    e.preventDefault();
    this.setState({ filter: e.target.value });
  }
  onNbestChange = (e) => {
    e.preventDefault();
    this.setState({ nbCoocToDisplay: e.target.value });
  }
  onCollocChange = (e) => {
    e.preventDefault();
    this.setState({ currentColloc: e.target.value });
  }

  calcColloc = (coll) => {
    var lemma=".*";
    var cat=".*";
    if (coll.match(/\bl=([^,]+)/)) {
      lemma=RegExp.$1;
    }
    if (coll.match(/\bc=([^,]+)/)) {
      cat=RegExp.$1;
    }
    return lemma+'_'+cat;
  }

  render() {
    const { warningIncompleteExtraction, t } = this.props;
    const timeIdSize=this.props.data.timeIdSize;
    const data=this.props.data.cooc.freqByColloc;
    const dataType=this.props.data.cooc.typeByTimeId;
    const sortedCollocs=this.props.data.sortedCollocs;
    const increasingCollocs=this.props.data.increasingCollocs;
    const decreasingCollocs=this.props.data.decreasingCollocs;
    const incDecCollocs=this.props.data.incDecCollocs;
    const decIncCollocs=this.props.data.decIncCollocs;
    const currentColloc=data[this.state.currentColloc]? 
      this.state.currentColloc:
      Object.keys(data)[0];

    const langFormat = Cookies.get(FRONT_USER_LANG_COOKIE_NAME)==="en"? "en-EN":"fr-FR";

    const labels={
      'freq':this.props.t('frequency'),
      'coocType':this.props.t('coocType'),
      'relFreq':this.props.t('relFrequency'),
      'cumu':this.props.t('cumFrequency'),
      'spec':this.props.t('specificity'),
      'timeSpec':this.props.t('timeSpecificity'),
      'size':this.props.t('timeSpanSize'),
    };

    var filterVal=this.state.filter;
    const type = this.state.displayType ;
    const typeLabel=labels[type];
    const typeLabelLower = typeLabel.toLowerCase();
    //console.log("currentColloc",currentColloc);
    //console.log("data",data);
    const disp = currentColloc? (data[currentColloc]?data[currentColloc].length:0):0;
    // data was previously a table of 6-uplets  [num,timeId,freqInTimeId,FreqGlobal,sizeOfTimeId,SizeGlobal]
    // then transformated into object {timeId,freq,spec}

    // constructing table element
    const table = (
      <MaterialTable
        columns={[
          { title: t('timeId'), field: 'timeId' },
          { title: typeLabel, field: type, render: rowData => <span className={estimatedClass(rowData[type],warningIncompleteExtraction)}>{rounded(rowData[type])}</span> },
        ]}
        data={currentColloc? data[currentColloc]:[]}
        title={typeLabel}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:typeLabelLower,
          exportAllData: true,
        }}
        components={{
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[10, 25, 50, 100,currentColloc? data[currentColloc].length:0]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
            />
          ),
        }}
      />
    );

    const c=Object.keys(data);
    // prep data for the main chart
    const collocs=sortedCollocs.filter((colloc)=>{ return (c.indexOf(colloc)!==-1 && (filterVal===""||colloc.match(RegExp(filterVal)))) });
    const selectOptions= collocs.map ( (colloc) =>  
        <option key={colloc} value={colloc}>{colloc}</option>
    );

    const series=[];

    // date format computation (based on the first data)
    const dateStruct=data[c[0]][0].timeId.split("-")[0].split("/").length;
    var dateFormat=(dateStruct===3)? "yyyy MMM dd" : (dateStruct===2) ? "yyyy MMM" : "yyyy"

    if (type==='size') {
      var timeIds=Object.keys(timeIdSize);
      const xyTab=[];
      
      for (var i=0;i<timeIds.length;i++) { 
        const timeId=timeIds[i];
        const ymd=timeId.split( "/");
        const year=ymd[0];
        const month=ymd[1]?ymd[1]:1;
        const day=ymd[2]?ymd[2]:1;
        const val= this.props.timeIdSize[timeId].size;
        //console.log(i,timeId,year,month,day,val)
        xyTab.push(
          { x: new Date(year,month,day).getTime(),
            y: val
          }
        );
      }
      series.push({ 
        name:typeLabel,
        data:xyTab,
      });
    } else {
      // slicing best collocs 
      var displayedCollocs=collocs.slice(0,this.state.nbCoocToDisplay);

      for (var j=0;j<displayedCollocs.length;j++) {
        const xyTab=[];
        var colloc=displayedCollocs[j];

        //console.log("ajout de la série pour "+colloc);

        for (i=0;i<data[colloc].length;i++) {
            const point=data[colloc][i];
            const timeId=point.timeId.split("-")[0];
            const ymd=timeId.split( "/");
            const year=ymd[0];
            const month=ymd[1]?ymd[1]:1;
            const day=ymd[2]?ymd[2]:1;
            const val= point[type];
            xyTab.push(
                { x: new Date(year,month,day).getTime(),
                  y: val
                }
            );
        }
        series.push({ 
            name:lemmaCat(colloc),
            data:xyTab
        });
      }
    }

    // prep data for the colloc type chart
    const serieCollocType=[]
    const xyTabType=[];
    if (dataType) {
      const timeIdsType=Object.keys(dataType).sort();
      for (i=0;i<timeIdsType.length;i++) {
        const timeId=timeIdsType[i];
        const nbType= dataType[timeId];
        const nbOcc=this.props.data.occs[i]['freq'];
        const val=this.state.collocTypeChoice==='collocTTR'? nbType/nbOcc: nbType;
        const ymd=timeId.split("/");
        const year=ymd[0];
        const month=ymd[1]?ymd[1]:1;
        const day=ymd[2]?ymd[2]:1;
        xyTabType.push(
            { x: new Date(year,month,day).getTime(),
              y: val
            }
        );
      }
    }
    serieCollocType.push({ 
      name:this.props.t('collocTypeByTimeId'),
      data:xyTabType
    });

    // prep data for the current colloc chart
    const serieCurrentColloc=[]
    const xyTab=[];
    if (currentColloc && data[currentColloc]) {
      for (i=0;i<data[currentColloc].length;i++) {
        const point=data[currentColloc][i];
        const timeId=point.timeId.split("-")[0];
        const ymd=timeId.split( "/");
        const year=ymd[0];
        const month=ymd[1]?ymd[1]:1;
        const day=ymd[2]?ymd[2]:1;
        const val= point[type];
        xyTab.push(
            { x: new Date(year,month,day).getTime(),
              y: val
            }
        );
      }
      serieCurrentColloc.push({ 
          name:lemmaCat(currentColloc),
          data:xyTab
      });
    }

    const options = {
        chart: {
          type: 'line',
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          position :'top'
        },
        tooltip: {
            enabled:true,
            x: {
                show: true,
                format: dateFormat,
                formatter: undefined,
            },
        },
        yaxis: {
            title: {
                text: t(typeLabel),
            },
            labels: {
                formatter: function (y) {
                  return rounded(y,2);
                }
            }
        },
        xaxis: {
            type: 'datetime',
            labels: {
                rotate: -90,
            },
            
        }
    };
    const optionsType = {
      chart: {
        type: 'line',
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        position :'top'
      },
      tooltip: {
          enabled:true,
          x: {
              show: true,
              format: dateFormat,
              formatter: undefined,
          },
      },
      yaxis: {
          title: {
              text: t(this.state.collocTypeChoice),
          },
          labels: {
              formatter: function (y) {
                return rounded(y,2);
              }
          }
      },
      xaxis: {
          type: 'datetime',
          labels: {
              rotate: -90,
          },
          
      }
    };

    const increasingCollocsList=Object.keys(increasingCollocs).sort( (a,b)=>  increasingCollocs[b].coeff-increasingCollocs[a].coeff).map( colloc =>
      <li key={colloc}>
        <Button minimal small onClick={()=> { this.props.performSearch({query:this.props.collocQuery[colloc]})} } >{this.calcColloc(colloc)}</Button>
        : {t('firstAttestation')}= {increasingCollocs[colloc].firstAttestation} (freq= {increasingCollocs[colloc].freq}, coeff= {increasingCollocs[colloc].coeff})
      </li>
    );
    const decreasingCollocsList=Object.keys(decreasingCollocs).sort( (a,b)=> decreasingCollocs[b].coeff-decreasingCollocs[a].coeff).map( colloc =>
      <li key={colloc}>
        <Button minimal small onClick={()=> { this.props.performSearch({query:this.props.collocQuery[colloc]})} } >{this.calcColloc(colloc)}</Button>
        : {t('lastAttestation')}= {decreasingCollocs[colloc].lastAttestation} (freq= {decreasingCollocs[colloc].freq}, coeff= {decreasingCollocs[colloc].coeff})
      </li>
    );
    const incDecCollocsList=Object.keys(incDecCollocs).sort( (a,b)=>  incDecCollocs[b].coeff-incDecCollocs[a].coeff).map( colloc =>
      <li key={colloc}>
        <Button minimal small onClick={()=> { this.props.performSearch({query:this.props.collocQuery[colloc]})} } >{this.calcColloc(colloc)}</Button>
        (freq= {incDecCollocs[colloc].freq}, coeff= {incDecCollocs[colloc].coeff})
      </li>
    );
    const decIncCollocsList=Object.keys(decIncCollocs).sort( (a,b)=> decIncCollocs[b].coeff-decIncCollocs[a].coeff).map( colloc =>
      <li key={colloc}>
        <Button minimal small onClick={()=> { this.props.performSearch({query:this.props.collocQuery[colloc]})} } >{this.calcColloc(colloc)}</Button>
        (freq= {decIncCollocs[colloc].freq}, coeff= {decIncCollocs[colloc].coeff})
      </li>
    );


    return(
    <>

      <Paper className="margin-bottom-1-5-rem padding-1-rem">
        <H2>{t('searchResults')}</H2>

        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('collocTypeByTimeId')}</u></H4>
          <FormGroup label={t('type')} labelFor='type' inline={true}>
            <HTMLSelect id='collocTypeChoice' name='collocTypeChoice' onChange={this.onCollocTypeChoiceChange}>
              <option value='collocType'>{t('collocType')}</option>
              <option value='collocTTR'>{t('collocTTR')}</option>
            </HTMLSelect>
          </FormGroup>
          <br/>
          <div onClick={this.initChart}>
            <Chart options={optionsType} series={serieCollocType} height={this.state.height}/> 
          </div>
        </div>


        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('detailedStats')}</u></H4>
          <FormGroup label={t('type')} labelFor='type' inline={true}>
            <HTMLSelect id='type' name='type' onChange={this.onTypeChange}>
              <option value='freq'>{t('freqByTimeId')}</option>
              <option value='relFreq'>{t('relFrequency')}</option>
              <option value='cumu'>{t('cumFreqByTimeId')}</option>
              <option value='spec'>{t('specByTimeId')}</option>
              <option value='timeSpec'>{t('timeSpecByTimeId')}</option>
              <option value='size'>{t('timeSpanSize')}</option>
            </HTMLSelect>
          </FormGroup>
        </div>

        <div className="margin-bottom-1-rem">
          <H6><u>{t('evolutionForMoreFrequentColloc')}</u></H6>
          <FormGroup
            helperText={t('filterUsingRegex')}
            inline={true}
            label={t('filter')}
          >
            <InputGroup
              value={filterVal}
              disabled={false}
              onChange={this.onFilterChange}
            />
          </FormGroup>

          <FormGroup label={t('nBest')} labelFor='type' inline={true}>
            <HTMLSelect id='nbest' name='nbest' onChange={this.onNbestChange}>
              <option value='5'>5</option>
              <option value='6'>6</option>
              <option value='7'>7</option>
              <option value='8'>8</option>
              <option value='9'>9</option>
              <option value='10'>10</option>
              <option value='15'>15</option>
              <option value='20'>20</option>              
            </HTMLSelect>
          </FormGroup>
          <br/>
          <br/>
          <div id="chartCooc" onClick={this.initChart}>
             <Chart options={options} series={series} height={this.state.height} />
          </div>
        </div>

        <div className="margin-bottom-1-5-rem">
          <p>{t('coeffExplanation')}</p>
          { increasingCollocsList.length>0 &&
            <>
              <H4><u>{t('increasingCollocs')}</u> <Icon icon='trending-up'/></H4>
              <ul>
                {increasingCollocsList}
              </ul>
            </>
          }
          { decreasingCollocsList.length>0 &&
            <>
              <H4><u>{t('decreasingCollocs')}</u> <Icon icon='trending-down'/></H4>
              <ul>
                {decreasingCollocsList}
              </ul>
            </>
          }
          { incDecCollocsList.length>0 &&
            <>
              <H4><u>{t('incDecCollocs')}</u> <Icon icon='trending-up'/><Icon icon='trending-down'/></H4>
              <ul>
                {incDecCollocsList}
              </ul>
            </>
          }
          { decIncCollocsList.length>0 &&
            <>
              <H4><u>{t('decIncCollocs')}</u> <Icon icon='trending-down'/><Icon icon='trending-up'/></H4>
              <ul>
                {decIncCollocsList}
              </ul>
            </>
          }

        </div>

        <div className="margin-bottom-1-5-rem">
          <H4><u>{t('choseColloc')}</u></H4>
          <FormGroup label={t('collocate')} labelFor='collocate' inline={true}>
            <HTMLSelect id='collocate' name='collocate' onChange={this.onCollocChange}>
                {selectOptions}
            </HTMLSelect>
          </FormGroup>
          <br/>
          <br/>
          <div onClick={this.initChart}>
            <Chart options={options} series={serieCurrentColloc} height={this.state.height}/> 
          </div>
        </div>

        { currentColloc && 
          <>
            <div className="margin-bottom-1-rem">
              <H4><u>{t('nbTimeSpan')}</u></H4>
              <ul>
                <li>{t('beginningColon')} {data[currentColloc][0].timeId}</li>
                <li>{t('endingColon')} {data[currentColloc][disp-1].timeId}</li>
                <li>{t('dispColon')} {Intl.NumberFormat(langFormat).format(disp)} </li>
              </ul>
              
            </div>

            <H6><u>{t('completeResList')}</u> - {currentColloc}</H6>
            
            {table}
          </>
        }
      </Paper>
    </>
    );
  }

}

ChronoCooc.propTypes = {
  data: PropTypes.object,
  warningIncompleteExtraction: PropTypes.bool,
  sessionId: PropTypes.string,
  collocQuery: PropTypes.object,
  performSearch: PropTypes.func,  
};

export default withTranslation()(ChronoCooc);
